export default "__VITE_ASSET__09149526__"